"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedValueForTooltip = exports.formatValueForTooltip = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var numberjs_1 = require("@gooddata/numberjs");
var common_1 = require("../_util/common");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
function formatValueForTooltip(val, format, separators) {
    var formattedObject = numberjs_1.colors2Object(numberjs_1.numberFormat(val, format, undefined, separators));
    return common_1.customEscape(formattedObject.label);
}
exports.formatValueForTooltip = formatValueForTooltip;
function getFormattedValueForTooltip(isDualChartWithRightAxis, stackMeasuresToPercent, point, separators, percentageValue) {
    var target = point.target, y = point.y, format = point.format;
    var isNotStackToPercent = stackMeasuresToPercent === false || isNil_1.default(percentageValue) || isDualChartWithRightAxis;
    return isNotStackToPercent
        ? formatValueForTooltip(target !== null && target !== void 0 ? target : y, format, separators)
        : common_1.percentFormatter(percentageValue);
}
exports.getFormattedValueForTooltip = getFormattedValueForTooltip;
//# sourceMappingURL=tooltip.js.map